/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earth_Day_2025_Landing_DescriptionInputs */

const en_earth_day_2025_landing_description = /** @type {(inputs: Earth_Day_2025_Landing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Forest Energy, together with others, is making real trees happen.`)
};

const ar_earth_day_2025_landing_description = /** @type {(inputs: Earth_Day_2025_Landing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قوة Forest الخاصة بك، مع الآخرين، تجعل الأشجار حقيقية.`)
};

const de_earth_day_2025_landing_description = /** @type {(inputs: Earth_Day_2025_Landing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Forest Power, zusammen mit anderen, lässt echte Bäume entstehen.`)
};

const es_earth_day_2025_landing_description = /** @type {(inputs: Earth_Day_2025_Landing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El poder de tu bosque, junto con el de otros, está haciendo que aparezcan árboles reales.`)
};

const fr_earth_day_2025_landing_description = /** @type {(inputs: Earth_Day_2025_Landing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre Pouvoir Forest, associé à celui des autres, permet de planter de véritables arbres.`)
};

const it_earth_day_2025_landing_description = /** @type {(inputs: Earth_Day_2025_Landing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo Forest Power, insieme ad altri, sta facendo crescere alberi veri.`)
};

const ja_earth_day_2025_landing_description = /** @type {(inputs: Earth_Day_2025_Landing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`他の人たちと共にForestパワーを蓄え、本物の木を植えましょう。`)
};

const ko_earth_day_2025_landing_description = /** @type {(inputs: Earth_Day_2025_Landing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모두의 Forest Power가 한데 모여 실제 나무를 심어요.`)
};

const pt_br_earth_day_2025_landing_description = /** @type {(inputs: Earth_Day_2025_Landing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu Poder do Forest, junto dos demais, está possibilitando árvores de verdade.`)
};

const ru_earth_day_2025_landing_description = /** @type {(inputs: Earth_Day_2025_Landing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваша сила Forest в сочетании с помощью других высаживает реальные деревья.`)
};

const th_earth_day_2025_landing_description = /** @type {(inputs: Earth_Day_2025_Landing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`พลังแห่ง Forest ของคุณ ร่วมกับพลังของคนอื่น ๆ กำลังทำให้เกิดการปลูกต้นไม้จริงขึ้น `)
};

const tr_earth_day_2025_landing_description = /** @type {(inputs: Earth_Day_2025_Landing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest gücün, diğerleriyle birlikte gerçek ağaçların dikilmesini sağlıyor.`)
};

const zh_cn_earth_day_2025_landing_description = /** @type {(inputs: Earth_Day_2025_Landing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你和大家共同累积的森林能量，将为地球带来更多的绿意！`)
};

const zh_tw_earth_day_2025_landing_description = /** @type {(inputs: Earth_Day_2025_Landing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你和大家共同累積的森林能量，將為地球帶來更多的綠意！`)
};

/**
* | output |
* | --- |
* | "Your Forest Energy, together with others, is making real trees happen." |
*
* @param {Earth_Day_2025_Landing_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const earth_day_2025_landing_description = /** @type {((inputs?: Earth_Day_2025_Landing_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earth_Day_2025_Landing_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earth_day_2025_landing_description(inputs)
	if (locale === "ar") return ar_earth_day_2025_landing_description(inputs)
	if (locale === "de") return de_earth_day_2025_landing_description(inputs)
	if (locale === "es") return es_earth_day_2025_landing_description(inputs)
	if (locale === "fr") return fr_earth_day_2025_landing_description(inputs)
	if (locale === "it") return it_earth_day_2025_landing_description(inputs)
	if (locale === "ja") return ja_earth_day_2025_landing_description(inputs)
	if (locale === "ko") return ko_earth_day_2025_landing_description(inputs)
	if (locale === "pt_br") return pt_br_earth_day_2025_landing_description(inputs)
	if (locale === "ru") return ru_earth_day_2025_landing_description(inputs)
	if (locale === "th") return th_earth_day_2025_landing_description(inputs)
	if (locale === "tr") return tr_earth_day_2025_landing_description(inputs)
	if (locale === "zh_cn") return zh_cn_earth_day_2025_landing_description(inputs)
	return zh_tw_earth_day_2025_landing_description(inputs)
});